import { GetServerDiscoveryStatus } from '../ApplicationServerManagement/ApplicationServerDiscoveryStatus';
import { AppManagerWikiLink } from './AppManagerWikiLink';
import { DateDisplay } from './DateDisplay';

interface ServerLastDiscoveredTimestampProps {
    lastDiscoveredTimestamp?: string;
    showWikiLink: boolean;
}
export function ServerLastDiscoveredTimestamp(props: ServerLastDiscoveredTimestampProps) {
    const lastDiscoveredTimestamp = props.lastDiscoveredTimestamp;
    const status = GetServerDiscoveryStatus(lastDiscoveredTimestamp);

    return (
        <span className={status.view.colorText}>
            <i className={'fa ' + status.view.icon} title={status.message}></i> <DateDisplay dateAsString={lastDiscoveredTimestamp} />
            {props.showWikiLink ? (
                <>
                    &nbsp;
                    <AppManagerWikiLink pagePath="Manage-Servers" anchor="last-discovery" />
                </>
            ) : (
                ''
            )}
        </span>
    );
}
